export default "__VITE_ASSET__kb_k_qwZ__"